import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import HotComics from './components/HotComics';
import PopularCategories from './components/PopularCategories';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫大全',
  url: 'https://www.manhuadaquan.com',
  description: '韩国漫画无删减漫画下拉式免费韩漫大全，资源丰富多元，更新速度快，让您第一时间感受韩漫魅力。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.manhuadaquan.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '韩漫大全 - 韩国漫画无删减免费阅读平台',
  description: '韩漫漫画网站推出无删减韩国漫画下拉式免费韩漫大全，资源丰富多元，更新速度快，让您第一时间感受韩漫魅力。',
  url: 'https://www.manhuadaquan.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '韩漫大全',
    url: 'https://www.manhuadaquan.com',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedComics />
        <LatestUpdates />
        <HotComics />
        <PopularCategories />
        <StatsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}